import React from 'react';

const RecentNotes = () => {
  const notes = [
    { date: "Nov 10, 2023", type: "Treatment Review" },
    { date: "Oct 28, 2023", type: "Follow-up Visit" },
    { date: "Oct 15, 2023", type: "Imaging Review" },
    { date: "Oct 01, 2023", type: "Treatment Planning" },
  ];
  
  return (
    <div className="bg-white p-4 rounded-lg shadow mb-4">
      <div className="flex justify-between items-center mb-3">
        <h2 className="text-xl font-medium">Recent Notes</h2>
        <button className="text-blue-500 hover:text-blue-700">
          New Note
        </button>
      </div>
      <ul className="space-y-2">
        {notes.map((note, index) => (
          <li key={index} className="flex items-start hover:bg-gray-50 p-1 rounded cursor-pointer">
            <span className="mr-2">•</span>
            <span className="font-medium">{note.date}</span>
            <span className="ml-2">- {note.type}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default RecentNotes;